module.exports = __webpack_public_path__ + "img/directionRight-disabled.66ee07a6.svg";